export default __webpack_public_path__ + "locales/sr-Latn-RS/People.json?hash=1b15370dfbc1729b4ff02dec8c6894ad";